import { render, staticRenderFns } from "./BaseFilterChip.vue?vue&type=template&id=3c471685&lang=pug"
import script from "./BaseFilterChip.vue?vue&type=script&lang=js"
export * from "./BaseFilterChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports